/* tslint:disable */
/* eslint-disable */
/**
 * EVE Swagger Interface
 * An OpenAPI for EVE Online
 *
 * The version of the OpenAPI document: 1.30
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * Error 520
 * @export
 * @interface GetMarketsRegionIdHistoryError520
 */
export interface GetMarketsRegionIdHistoryError520 {
    /**
     * Error 520 message
     * @type {string}
     * @memberof GetMarketsRegionIdHistoryError520
     */
    error?: string;
}

/**
 * Check if a given object implements the GetMarketsRegionIdHistoryError520 interface.
 */
export function instanceOfGetMarketsRegionIdHistoryError520(value: object): value is GetMarketsRegionIdHistoryError520 {
    return true;
}

export function GetMarketsRegionIdHistoryError520FromJSON(json: any): GetMarketsRegionIdHistoryError520 {
    return GetMarketsRegionIdHistoryError520FromJSONTyped(json, false);
}

export function GetMarketsRegionIdHistoryError520FromJSONTyped(json: any, ignoreDiscriminator: boolean): GetMarketsRegionIdHistoryError520 {
    if (json == null) {
        return json;
    }
    return {
        
        'error': json['error'] == null ? undefined : json['error'],
    };
}

export function GetMarketsRegionIdHistoryError520ToJSON(json: any): GetMarketsRegionIdHistoryError520 {
    return GetMarketsRegionIdHistoryError520ToJSONTyped(json, false);
}

export function GetMarketsRegionIdHistoryError520ToJSONTyped(value?: GetMarketsRegionIdHistoryError520 | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'error': value['error'],
    };
}

